export const buildHeartbeats = (input)=>({
        accountId: input.accountId,
        snapshots: [
            toSnapshot('main_thread', 'n_a', input.main),
            toSnapshot('shared_worker', input.workerUrlKind, input.worker)
        ]
    });
const toSnapshot = (source, workerUrlKind, stats)=>({
        source,
        workerUrlKind,
        connections: stats.connections,
        workerClients: stats.workerClients,
        channels: stats.channels,
        projectsSubscribed: stats.projectsSubscribed,
        messagesReceived1m: stats.messagesReceived1m
    });
